import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval, sqsMessageBatchSize } = formData;
  const handleSubmit = () => {
    if (formError) {
      return;
    }
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: t("common.validation.polling_interval_invalid"),
        nice_message: t("common.validation.polling_interval_min")
      });
      return;
    }
    if ((sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value) && (sqsMessageBatchSize.value < 1 || sqsMessageBatchSize.value > 10)) {
      setFormError({
        full_message: t("common.validation.sqs_batch_size_invalid"),
        nice_message: t("common.validation.sqs_batch_size_range")
      });
      return;
    }
    setFormError(null);
    onSubmit();
  };
  const handleSqsMessageBatchSizeChange = (errorMessage) => {
    if (errorMessage) {
      setFormError({
        full_message: errorMessage,
        nice_message: errorMessage
      });
    } else {
      setFormError(null);
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("aws_security_lake.fields.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange, handleSqsMessageBatchSizeChange })
  );
};
export default StepSubscribe;
